<template>
  <div class="workspace">
    <TopHeader />
    <Navi />

    <fluidBend />
    <div class="wrapper">
      <b-container fluid class="bigcont">
        <ItemList :style="sidebarWidth" />
        <div draggable="true" @dragover="onDragOver" @dragend="onDragEnd"></div>
        <ItemForm />
      </b-container>
    </div>
  </div>
</template>

<script>
import TopHeader from "@/components/Header";
import Navi from "@/components/Navi";

import FluidBend from "@/components/FluidBend";

import EventBox from "@/components/EventBox";

import SimpleChart from "@/components/SimpleChart.js";

import ItemList from "@/components/ItemList";
import ItemForm from "@/components/ItemForm";

export default {
  components: {
    TopHeader,
    Navi,
    ItemList,
    ItemForm,
    FluidBend,

    // SimpleChart,
  },
  data() {
    return {
      sidebarWidth: "width:48%",
    };
  },
  methods: {
    onDragOver(event) {},
    onDragEnd(event) {
      this.sidebarWidth = `width:${event.clientX}px`;
    },
  },
};
</script>


<style lang="scss" scoped>
.wrapper {
  padding-top: 10px;
  //   padding-bottom: 25px;
}
.bigcont {
  display: flex;
  width: 100vw;
  min-height: calc(100vh - 180px);
  //   background-color: red;

  div:nth-child(1) {
    width: 48%;
  }
  div:nth-child(2) {
    width: 5px;
    background-color: darkgray;
    position: relative;
  }
  div:nth-child(3) {
    width: auto;
    padding-left: 10px;
  }
}
</style>